export enum AnnouncementType {
    NEW_VERSION_UPDATES = 'NEW VERSION UPDATES',
    PERSONAL_ASSISTANT_UPDATES = 'PERSONAL ASSISTANT UPDATES',
    AI_CREATION_MODELS_UPDATE = 'AI CREATION MODELS UPDATE',
}

export enum AnnouncementLayoutType {
    LARGE = 'large',
    REGULAR = 'regular',
}

export interface ContentItem {
    title: string;
    description: string;
}

export interface Hyperlink {
    url: string;
    text: string;
}

export interface Announcement {
    id: number;
    type: AnnouncementType;
    title?: string;
    description?: string;
    content?: ContentItem[];
    imageUrl?: string;
    hyperlink?: Hyperlink;
    visible: boolean;
    createdAt: Date;
    updatedAt: Date;
    layoutType: AnnouncementLayoutType;
}
